import { Injectable } from '@angular/core';
import { AlertController, LoadingController } from '@ionic/angular';
import { EventsService } from './events.service';
import { SliderService } from './slider.service';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(
    public alertController: AlertController,
    public loadingController: LoadingController,
    private eventsService: EventsService,
    private sliderService: SliderService
  ) {}

  async deleteEvent(id) {
    const alert = await this.alertController.create({
      header: 'Delete Event?',
      message: 'Are you sure you want to delete this event?',
      buttons: [
        {
          text: 'Yes',
          handler: () => {
            this.eventsService.deleteEvent(id);
          },
        },
        {
          text: 'No',
          role: 'cancel',
          cssClass: 'danger',
          handler: (blah) => {},
        },
      ],
    });

    await alert.present();
  }

  async deleteSlider(id) {
    const alert = await this.alertController.create({
      header: 'Delete Slider?',
      message: 'Are you sure you want to delete this slider?',
      buttons: [
        {
          text: 'Yes',
          handler: () => {
            this.sliderService.deleteSlider(id);
          },
        },
        {
          text: 'No',
          role: 'cancel',
          cssClass: 'danger',
          handler: (blah) => {},
        },
      ],
    });

    await alert.present();
  }

  async createdEventAlert() {
    const alert = await this.alertController.create({
      header: 'Event created',
      message: 'The event was succesfully created',
      buttons: ['OK'],
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
    // console.log('onDidDismiss resolved with role', role);
  }

  async createdSliderAlert() {
    const alert = await this.alertController.create({
      header: 'Slider created',
      message: 'The slider was succesfully created',
      buttons: ['OK'],
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
    // console.log('onDidDismiss resolved with role', role);
  }

  async wrongFormularyAlert() {
    const alert = await this.alertController.create({
      header: 'Invalid formulary',
      message: 'Please check if you fill up all the inputs',
      buttons: ['OK'],
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
    // console.log('onDidDismiss resolved with role', role);
  }

  async updateFormularyAlert() {
    const alert = await this.alertController.create({
      header: 'Updated formulary',
      message: 'The formulary has been successfully updated',
      buttons: ['OK'],
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
    // console.log('onDidDismiss resolved with role', role);
  }

  async errorAlert(header, message) {
    const alert = await this.alertController.create({
      header: header,
      message: message,
      buttons: ['OK'],
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
    // console.log('onDidDismiss resolved with role', role);
  }
}
